module.exports = __webpack_public_path__ + "static/img/pico41.dc9fd5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico41.png
// module id = oPb4
// module chunks = 0